import useQuery from './useQuery';

/** M9 (#148): team roster + pending invites + seat usage for a seller.
 * Owner/Manager only — the API 403s other roles, so callers gate `enabled`. */
function useTeamQuery(sellerId, params) {
  return useQuery(`/sellers/${sellerId}/team/`, {
    enabled: Boolean(sellerId),
    staleTime: 30 * 1000,
    ...params,
  });
}

export default useTeamQuery;
